import s from '@corratech/air-ooka-header/Navbar/Navbar.module.scss'
import React from 'react'
import { useRouter } from 'next/router'
import { useAlfakherContext } from '@components/alfakherContext/AlfakherContext'

export const CustomKitBackButton = () => {
    const { back } = useRouter()
    // @ts-ignore
    const { bundleStep, setBundleStep } = useAlfakherContext()
    return (
        <span
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if(e.key === 'Enter'){
                    if (bundleStep > 0) {
                    return setBundleStep(bundleStep - 1)
                }
                back()
                }
            }}
            onClick={() => {
                if (bundleStep > 0) {
                    return setBundleStep(bundleStep - 1)
                }
                back()
            }}
            className={s['backArrow']}
        >
            <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M28 31.9998L20 23.9998L28 15.9998"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    )
}
